import React from "react"
import styled from "styled-components"
import { transform } from "typescript"

interface Props {
  isActive: boolean
}

const IconTagsSelectionOpen: React.FC<Props> = ({ isActive }) => {
  return (
    <>
      {isActive ? (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.75 0.875C1.51794 0.875 1.29538 0.967187 1.13128 1.13128C0.967187 1.29538 0.875 1.51794 0.875 1.75V5.76275C0.87505 5.9948 0.967269 6.21732 1.13137 6.38138L7.25638 12.5064C7.42046 12.6704 7.64298 12.7626 7.875 12.7626C8.10702 12.7626 8.32954 12.6704 8.49362 12.5064L12.5064 8.49362C12.6704 8.32954 12.7626 8.10702 12.7626 7.875C12.7626 7.64298 12.6704 7.42046 12.5064 7.25638L6.38138 1.13137C6.21732 0.967269 5.9948 0.87505 5.76275 0.875H1.75ZM5.25 3.9375C5.25 4.2856 5.11172 4.61944 4.86558 4.86558C4.61944 5.11172 4.2856 5.25 3.9375 5.25C3.5894 5.25 3.25556 5.11172 3.00942 4.86558C2.76328 4.61944 2.625 4.2856 2.625 3.9375C2.625 3.5894 2.76328 3.25556 3.00942 3.00942C3.25556 2.76328 3.5894 2.625 3.9375 2.625C4.2856 2.625 4.61944 2.76328 4.86558 3.00942C5.11172 3.25556 5.25 3.5894 5.25 3.9375Z"
            fill="white"
          />
        </svg>
      ) : (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.75 0.875C1.51794 0.875 1.29538 0.967187 1.13128 1.13128C0.967187 1.29538 0.875 1.51794 0.875 1.75V5.76275C0.87505 5.9948 0.967269 6.21732 1.13137 6.38138L7.25638 12.5064C7.42046 12.6704 7.64298 12.7626 7.875 12.7626C8.10702 12.7626 8.32954 12.6704 8.49362 12.5064L12.5064 8.49362C12.6704 8.32954 12.7626 8.10702 12.7626 7.875C12.7626 7.64298 12.6704 7.42046 12.5064 7.25638L6.38138 1.13137C6.21732 0.967269 5.9948 0.87505 5.76275 0.875H1.75ZM5.25 3.9375C5.25 4.2856 5.11172 4.61944 4.86558 4.86558C4.61944 5.11172 4.2856 5.25 3.9375 5.25C3.5894 5.25 3.25556 5.11172 3.00942 4.86558C2.76328 4.61944 2.625 4.2856 2.625 3.9375C2.625 3.5894 2.76328 3.25556 3.00942 3.00942C3.25556 2.76328 3.5894 2.625 3.9375 2.625C4.2856 2.625 4.61944 2.76328 4.86558 3.00942C5.11172 3.25556 5.25 3.5894 5.25 3.9375Z"
            fill="#A7A7A7"
          />
        </svg>
      )}
    </>
  )
}
const RotateWrapper = styled.div<{ isOpen: boolean }>`
  transition: all 0.5s;

  ${props => props.isOpen && "transform: rotate(-180deg);"};
`

export default IconTagsSelectionOpen
